<template>
  <VoucherLedgerList
    flag="DR"
    :title="$t('debit_voucher')"
    create-route="DebitVoucherCreate"
    :create-label="$t('add_debit_voucher')"
    table-id="DebitVoucherTable"
    head-icon="ti-receipt"
  />
</template>

<script>
import VoucherLedgerList from '@/components/accounts/VoucherLedgerList.vue';

export default {
  components: { VoucherLedgerList },
};
</script>
